export const categories = [
  { slug: 'wanghong-baoliao', name: '网红爆料', icon: 'ri-fire-line', description: '最新网红黑料一手掌握' },
  { slug: 'yule-quan', name: '娱乐圈', icon: 'ri-movie-line', description: '娱乐圈明星八卦合集' },
  { slug: 'zhibo-quan', name: '直播圈', icon: 'ri-live-line', description: '直播圈内幕大揭秘' },
  { slug: 'zhubo-bagua', name: '主播八卦', icon: 'ri-mic-line', description: '各大主播私密爆料' },
  { slug: 'zongyi-chigua', name: '综艺吃瓜', icon: 'ri-tv-line', description: '综艺节目幕后的故事' },
  { slug: 'shehui-redian', name: '社会热点', icon: 'ri-earth-line', description: '热点事件深度追踪' },
];

export const articles = [
  {
    id: '1',
    slug: 'wanghong-a-lou-shui-ta-fang',
    title: '知名网红A被曝漏税数千万，工作室连夜发声明回应',
    excerpt: '近日，网红A被网友实名举报涉嫌偷税漏税高达数千万，税务部门已介入调查。其工作室凌晨紧急发布声明，称将全力配合调查...',
    content: `<p>近日，知名网红A因税务问题再次成为舆论焦点。据知情人士透露，有网友在社交平台实名举报该网红涉嫌通过多家壳公司转移收入，偷逃税款金额高达数千万元。</p><p>消息一出，立刻在各大社交平台引发热议。不少网友纷纷在评论区表达震惊与失望，有网友表示："一直以来都很喜欢她，没想到背后竟然是这样。"也有网友呼吁相关部门彻查到底。</p><p>面对愈演愈烈的舆论风波，网红A的工作室于凌晨3点紧急发布声明。声明中表示，该网红一直以来均按照国家法律法规纳税，所有经营行为均合法合规，不存在所谓的偷税漏税行为。同时，工作室表示将全力配合税务部门的调查工作，以证清白。</p><p>业内人士分析认为，近年来网红经济蓬勃发展，部分头部网红的年收入已经超过一线明星。随之而来的税务合规问题也日益受到关注。此前已有数位知名主播因税务问题被查处，此次事件无论结果如何，都将对整个行业产生深远影响。</p><p>截至目前，税务部门尚未对此事做出正式回应。本网将持续关注事件进展。</p>`,
    category: 'wanghong-baoliao',
    author: '吃瓜小编',
    date: '2026-07-07',
    views: 128500,
    tags: ['网红', '偷税漏税', '实名举报'],
    imageSeq: 'article-01',
    imageQuery: 'Dramatic%20dark%20background%20with%20spotlight%20effect%2C%20a%20silhouette%20of%20a%20social%20media%20influencer%20on%20stage%2C%20mysterious%20atmosphere%2C%20cinematic%20lighting%2C%20warm%20amber%20and%20deep%20brown%20tones%2C%20editorial%20photography%20style%2C%20high%20contrast%2C%20artistic%20composition%2C%20abstract%20background%20with%20soft%20bokeh%20lights',
  },
  {
    id: '2',
    slug: 'zhubo-b-zhibo-jian-feng-hao',
    title: '主播B直播间突然被封，粉丝集体维权要求平台给说法',
    excerpt: '拥有百万粉丝的游戏主播B近日直播时突然被封号，粉丝群体在社交平台发起维权话题，要求平台方给出合理解释...',
    content: `<p>游戏区知名主播B在近日的一次直播中，突然遭遇平台封号处理，引发粉丝群体强烈不满。据悉，该主播拥有超过300万粉丝，是游戏区的顶流主播之一。</p><p>据观看直播的粉丝回忆，当时主播B正在进行正常的游戏直播，直播画面突然中断，随后账号状态显示为"违规封禁"。令人疑惑的是，直播全程并无明显违规内容。</p><p>事件发生后，主播B的粉丝群体迅速在各大社交平台发起维权行动，相关话题在短时间内冲上热搜。粉丝们纷纷@平台官方账号，要求给出明确的封禁理由和处理依据。</p><p>有业内人士猜测，此次封号可能与平台内部的流量竞争有关。近期该平台正在进行内容生态调整，多位头部主播的流量都出现了不同程度的波动。主播B此前曾公开表示对平台的某些政策不满，不排除此次封号是平台方面的回应。</p><p>截至目前，平台方尚未对此事做出正式回应。主播B本人也未通过任何渠道发声。该事件仍在持续发酵中。</p>`,
    category: 'zhibo-quan',
    author: '前线记者',
    date: '2026-07-06',
    views: 96500,
    tags: ['主播', '平台封号', '粉丝维权', '直播圈'],
    imageSeq: 'article-02',
    imageQuery: 'Dramatic%20scene%20of%20a%20gaming%20streamer%20setup%20in%20darkness%2C%20monitor%20showing%20error%20screen%2C%20neon%20red%20and%20blue%20ambient%20lighting%2C%20mysterious%20mood%2C%20cinematic%20composition%2C%20gaming%20peripherals%20in%20shadow%2C%20editorial%20photography%2C%20dramatic%20contrast%2C%20warm%20dark%20tones',
  },
  {
    id: '3',
    slug: 'nvyi-xinpian-hou-chang-feng-bo',
    title: '某女艺人新片片场耍大牌？工作人员匿名爆料内幕',
    excerpt: '一位自称某剧组工作人员的网友发帖爆料，称某当红女艺人在片场频繁迟到、对工作人员态度恶劣，引发热议...',
    content: `<p>近日，一条关于某当红女艺人在片场耍大牌的爆料帖在社交平台引发广泛关注。一位自称是某正在拍摄的电视剧剧组工作人员的网友，以匿名方式详细描述了该艺人在片场的种种不当行为。</p><p>据该爆料人描述，这位女艺人经常无故迟到，有时甚至让全组人员等待两三个小时。到达片场后，对化妆、服装等工作人员态度恶劣，频繁挑剔。更令人震惊的是，该艺人还曾因为对午餐不满意而当众摔餐盒，导致现场气氛一度十分尴尬。</p><p>帖子发出后，迅速引发了网友的热烈讨论。有网友表示："现在的明星真是越来越飘了"，也有网友持保留态度："匿名爆料可信度存疑，还是要理性看待。"不过有多位自称业内人士的网友在评论区表示，该艺人的类似行为在圈内早有传闻。</p><p>截至目前，该女艺人的经纪团队尚未对此事做出回应。该剧的出品方也表示不了解具体情况，称将进行内部调查。</p>`,
    category: 'yule-quan',
    author: '娱乐圈观察员',
    date: '2026-07-05',
    views: 187200,
    tags: ['女艺人', '片场', '耍大牌', '娱乐圈'],
    imageSeq: 'article-03',
    imageQuery: 'Film%20set%20atmosphere%20with%20director%20chair%20in%20spotlight%2C%20empty%20set%20with%20professional%20equipment%2C%20dramatic%20cinematic%20lighting%2C%20warm%20golden%20and%20deep%20shadow%20tones%2C%20movie%20production%20behind%20the%20scenes%2C%20editorial%20photography%20style%2C%20atmospheric%20mood',
  },
  {
    id: '4',
    slug: 'zongyi-jie-mu-nei-mu-bao-guang',
    title: '热门综艺节目被曝剧本造假，选手淘汰早有内定？',
    excerpt: '某选秀综艺被知情人士爆料称淘汰环节存在严重剧本操作，多位选手的排名和去留早在录制前就已确定...',
    content: `<p>一档正在热播的选秀类综艺节目近日陷入"剧本造假"争议。据一位自称参与节目制作的内部人士爆料，节目中的淘汰环节存在严重的剧本操作，选手的排名和去留早在节目录制前就已经基本确定。</p><p>该知情人士透露，节目组会在录制前召开内部会议，根据选手的商业价值、话题度和经纪公司背景来确定"剧本走向"。一些实力强劲但缺乏话题度的选手会被早早淘汰，而一些实力一般但具有话题性的选手则会被一路保送。</p><p>此爆料一出，立刻在粉丝群体中引发轩然大波。多位被淘汰选手的粉丝表示此前就觉得淘汰结果不合理，现在终于找到了原因。纷纷在节目官方账号下留言要求给个说法。</p><p>节目组随后发布声明，坚决否认存在剧本操作，称所有比赛结果均由专业评审团和观众投票共同决定，公平公正公开。但这一回应并未平息质疑，反而有更多"内部人士"站出来爆料更多细节。</p>`,
    category: 'zongyi-chigua',
    author: '综艺侦探',
    date: '2026-07-04',
    views: 215000,
    tags: ['综艺', '剧本造假', '选秀', '内定'],
    imageSeq: 'article-04',
    imageQuery: 'Television%20studio%20stage%20with%20dramatic%20spotlights%2C%20empty%20judges%20panel%2C%20reality%20show%20set%20design%2C%20dark%20atmosphere%20with%20golden%20accent%20lights%2C%20cinematic%20composition%2C%20behind%20the%20scenes%20drama%2C%20editorial%20photography%2C%20warm%20dark%20tones%20with%20theatrical%20lighting',
  },
  {
    id: '5',
    slug: 'daihuo-yi-jie-shouhou-beiju',
    title: '带货一姐直播翻车！宣称"纯天然"产品被检出有害成分',
    excerpt: '某头部带货主播力荐的美妆产品被消费者送检后发现含有违禁成分，该主播此前多次强调产品"纯天然、零添加"...',
    content: `<p>直播带货领域再出翻车事件。被誉为"带货一姐"的某头部主播近日陷入产品质量争议，其力荐的一款美妆产品被消费者送检后发现含有违禁成分。</p><p>事情的起因是一位消费者在使用该产品后出现严重过敏反应，遂将产品送至第三方检测机构进行检测。检测结果显示，该产品中含有国家明令禁止在化妆品中使用的某种激素类成分。而该主播在直播中曾多次强调产品"纯天然、零添加、孕妇可用"。</p><p>检测报告在社交平台曝光后，迅速引发广泛关注。大量购买过该产品的消费者纷纷表示担忧，要求退款并追究责任。有法律界人士指出，如果情况属实，该主播可能面临虚假宣传的法律责任。</p><p>面对舆论压力，该主播在最新一场直播中含泪道歉，表示已第一时间下架涉事产品，并将全力配合相关部门的调查。同时承诺对所有购买该产品的消费者进行无条件退款。但消费者似乎并不买账，相关话题仍在持续发酵。</p>`,
    category: 'wanghong-baoliao',
    author: '消费维权记者',
    date: '2026-07-03',
    views: 356000,
    tags: ['直播带货', '产品翻车', '虚假宣传', '消费者维权'],
    imageSeq: 'article-05',
    imageQuery: 'Cosmetic%20products%20scattered%20on%20dark%20surface%20under%20dramatic%20lighting%2C%20one%20broken%20bottle%2C%20mysterious%20laboratory%20atmosphere%2C%20warm%20amber%20and%20dark%20brown%20tones%2C%20editorial%20product%20photography%2C%20high%20contrast%2C%20investigative%20mood%2C%20soft%20shadows',
  },
  {
    id: '6',
    slug: 'yinyue-qu-boss-zhibo-jian-dui-ma',
    title: '音乐区两大头部主播直播间互怼，粉丝站队火药味十足',
    excerpt: '音乐区两位拥有千万粉丝的主播在各自直播间隔空互怼，从音乐理念分歧上升到人身攻击，双方粉丝激烈对线...',
    content: `<p>音乐直播区近日上演了一出"神仙打架"的戏码。两位拥有千万粉丝级别的头部音乐主播，在各自的直播间展开了长达数小时的隔空互怼。</p><p>事情的导火索是其中一位主播在直播中评价另一位主播的原创歌曲"毫无音乐性可言，纯粹是靠流量堆出来的"。这番言论被粉丝截图传播后，另一位主播在当晚的直播中进行了回击，称对方"吃不到葡萄说葡萄酸，自己的歌连排行榜都上不去"。</p><p>随着双方你来我往的隔空喊话，事态逐渐升级。从最初的音乐理念分歧，逐渐演变为互相揭短的人身攻击。双方的粉丝群体也迅速站队，在各大社交平台展开激烈对线，相关话题多次登上热搜。</p><p>有业内人士分析，两位主播之间的矛盾由来已久，此次公开爆发可能与其背后的经纪公司竞争有关。也有观点认为，这可能是一场精心策划的"互炒"，目的是为双方即将发布的新作品造势。</p>`,
    category: 'zhibo-quan',
    author: '音乐圈观察员',
    date: '2026-07-02',
    views: 289000,
    tags: ['音乐区', '主播互怼', '粉丝对战', '直播圈'],
    imageSeq: 'article-06',
    imageQuery: 'Two%20spotlights%20facing%20each%20other%20on%20dark%20stage%2C%20musical%20instruments%20in%20shadow%2C%20dramatic%20confrontation%20atmosphere%2C%20warm%20golden%20and%20deep%20red%20lighting%2C%20cinematic%20composition%2C%20editorial%20photography%2C%20tense%20mood%2C%20theatrical%20setup',
  },
  {
    id: '7',
    slug: 'nanzhu-bo-si-sheng-huo-bao-guang',
    title: '知名男主播私生活混乱？前女友放出大量聊天记录',
    excerpt: '一位自称某男主播前女友的网友在社交平台放出多张聊天截图，指控该主播在恋爱期间多次出轨...',
    content: `<p>又一位网红陷入了私生活争议。近日，一位自称是某知名男主播前女友的网友，在社交平台连续发布了多条动态，并附上了大量聊天记录截图，指控该主播在与自己交往期间多次出轨。</p><p>从放出的聊天记录来看，该男主播同时与多位女性保持着暧昧关系，聊天内容尺度颇大。这位前女友表示，自己是在无意中发现了这些聊天记录，才意识到自己一直被蒙在鼓里。她表示选择公开这些信息，是希望提醒其他女性不要上当受骗。</p><p>事件发酵后，该男主播的社交账号评论区迅速被攻陷。大量粉丝表示震惊和失望，有粉丝留言"关注你三年了，没想到你是这样的人"。同时也有不少网友质疑聊天记录的真实性，认为可能是P图伪造。</p><p>截至目前，该男主播尚未对此事做出任何回应。其经纪公司仅表示"正在了解情况"，未给出更多信息。该事件仍在持续发酵中，本网将持续关注。</p>`,
    category: 'zhubo-bagua',
    author: '八卦小能手',
    date: '2026-07-01',
    views: 432000,
    tags: ['男主播', '私生活', '出轨', '聊天记录'],
    imageSeq: 'article-07',
    imageQuery: 'Smartphone%20screen%20displaying%20chat%20messages%20in%20dark%20environment%2C%20dramatic%20moody%20lighting%2C%20mysterious%20atmosphere%2C%20warm%20amber%20glow%20from%20phone%20screen%2C%20editorial%20photography%2C%20intimate%20yet%20dramatic%20composition%2C%20dark%20background%20with%20bokeh%20effect',
  },
  {
    id: '8',
    slug: 'ying-shi-gong-si-qian-kuan-bao-liao',
    title: '某影视公司被曝拖欠员工工资，多名艺人解约出走',
    excerpt: '知名影视制作公司被内部员工爆料长期拖欠工资和项目款，旗下多位签约艺人已提出解约...',
    content: `<p>娱乐圈再传经营危机。一家曾出品多部热门剧集的知名影视制作公司，近日被内部员工爆料长期拖欠工资和项目款项，公司运营状况堪忧。</p><p>据多位匿名员工透露，公司从去年下半年开始就出现资金周转问题，员工工资经常延迟发放，有时甚至拖欠数月。一些外包项目的合作方也表示，项目款迟迟未能结清，已经影响到正常的业务合作。</p><p>雪上加霜的是，受此影响，公司旗下多位签约艺人已经提出解约。其中包括几位正当红的一线演员，他们的离开无疑将给公司带来更大的打击。有消息称，部分艺人已经在接触其他经纪公司。</p><p>该公司创始人此前曾在公开场合表示，公司正在积极进行融资，预计很快会有好消息。但截至目前，融资进展似乎并不顺利。业内人士分析，如果短期内无法解决资金问题，该公司可能面临破产风险。</p>`,
    category: 'yule-quan',
    author: '财经娱乐记者',
    date: '2026-06-30',
    views: 167000,
    tags: ['影视公司', '拖欠工资', '艺人解约', '娱乐圈'],
    imageSeq: 'article-08',
    imageQuery: 'Empty%20modern%20office%20space%20with%20dim%20lighting%2C%20abandoned%20desks%2C%20corporate%20atmosphere%20in%20decline%2C%20dramatic%20warm%20and%20dark%20tones%2C%20editorial%20photography%2C%20melancholic%20mood%2C%20soft%20shadows%2C%20business%20crisis%20theme',
  },
  {
    id: '9',
    slug: 'mei-zhuang-bo-zhu-zhi-bo-jian-jia-huo',
    title: '美妆博主直播间卖假货被实锤？消费者集体投诉到消协',
    excerpt: '多位消费者反映在某知名美妆博主直播间购买的大牌化妆品经鉴定为假货，消费者已集体向消协投诉...',
    content: `<p>直播带货假货问题再次引发关注。近日，多位消费者在社交平台反映，在某拥有500万粉丝的美妆博主直播间购买的所谓"正品保证"大牌化妆品，经专业鉴定均为假货。</p><p>据消费者描述，这些产品在外包装上与正品极为相似，普通消费者很难辨别。但使用后出现各种问题，有人皮肤过敏，有人发现产品质地和气味与正品明显不同。后经专业机构鉴定，确认均为高仿假货。</p><p>事件曝光后，越来越多的消费者站出来表示自己也买到了假货。据不完全统计，涉及的消费者已超过千人，涉案金额可能高达数百万元。目前，部分消费者已经联合向消费者协会进行了投诉。</p><p>该美妆博主在事件曝光后发布了一段道歉视频，表示自己也是被供应商欺骗，并不知道产品是假货。但消费者对此并不买账，认为作为带货主播应当对产品质量负责。目前，相关监管部门已经介入调查。</p>`,
    category: 'wanghong-baoliao',
    author: '打假小分队',
    date: '2026-06-29',
    views: 521000,
    tags: ['美妆博主', '假货', '消费者投诉', '直播带货'],
    imageSeq: 'article-09',
    imageQuery: 'Luxury%20cosmetic%20products%20under%20magnifying%20glass%20on%20dark%20surface%2C%20investigative%20atmosphere%2C%20dramatic%20lighting%2C%20warm%20golden%20and%20dark%20brown%20tones%2C%20editorial%20product%20photography%2C%20high%20contrast%2C%20forensic%20mood%2C%20mysterious%20shadows',
  },
  {
    id: '10',
    slug: 'youxi-qu-zhu-bo-kai-gua-feng-bo',
    title: '游戏区顶流主播被质疑开挂，线下自证直播引百万围观',
    excerpt: '一位游戏区顶流主播因操作过于精准被对手质疑使用外挂，主播随即开启线下自证直播吸引超百万观众...',
    content: `<p>游戏直播圈又起波澜。一位在射击游戏领域拥有极高人气的主播，近日因为在比赛中表现出超乎常人的精准操作，被多位职业选手和对手公开质疑使用了外挂程序。</p><p>质疑的声音最初来自一场线上比赛，有参赛选手指出该主播的瞄准轨迹和反应速度"不像是人类能够做到的"。随后，多位职业选手也表达了类似的看法，认为其操作存在诸多可疑之处。</p><p>面对铺天盖地的质疑，该主播做出了一个出人意料的决定——开启线下自证直播。他在一个配备了多角度摄像头的线下场地进行直播，全程展示自己的操作环境，包括电脑屏幕、鼠标键盘和外设等。这场自证直播吸引了超过百万观众同时在线观看。</p><p>在自证直播中，该主播依旧展现了惊人的游戏水平。大部分观众认为这足以证明其清白，但仍有部分质疑者认为线下环境也可以做手脚。这场"开挂风波"似乎还远未结束。</p>`,
    category: 'zhibo-quan',
    author: '电竞前线',
    date: '2026-06-28',
    views: 678000,
    tags: ['游戏主播', '开挂质疑', '自证直播', '电竞'],
    imageSeq: 'article-10',
    imageQuery: 'Gaming%20setup%20with%20multiple%20monitors%20in%20dark%20room%2C%20dramatic%20neon%20lighting%2C%20competitive%20esports%20atmosphere%2C%20warm%20red%20and%20dark%20blue%20tones%2C%20cinematic%20composition%2C%20editorial%20photography%2C%20tense%20gaming%20mood%2C%20professional%20setup',
  },
  {
    id: '11',
    slug: 'wanghong-c-yin-si-quan-zheng-yi',
    title: '网红C被指侵犯他人隐私权，未经允许偷拍路人入镜',
    excerpt: '户外直播网红C因在直播中未经允许将路人拍摄入镜，被指侵犯他人隐私权，当事人已委托律师发函...',
    content: `<p>户外直播领域的隐私问题再次成为焦点。一位以街头采访和户外互动为主要内容的网红C，近日因在直播中未经允许将多位路人拍摄入镜，被指控侵犯他人隐私权。</p><p>据悉，有路人在发现自己出现在该网红的直播间后表示强烈不满，称自己在不知情的情况下被拍摄，而且直播间的弹幕中有大量对其外貌和穿着的负面评论，给自己造成了严重的心理困扰。该路人已委托律师向网红C发出了律师函。</p><p>这一事件引发了关于户外直播边界的广泛讨论。有法律专家指出，在公共场合进行拍摄本身并不违法，但如果将拍摄内容用于商业目的（直播打赏属于商业行为），且对被拍摄者造成了负面影响，就可能构成侵权。</p><p>网红C随后发布道歉声明，表示今后会在直播中注意保护路人的隐私，对于已经造成困扰的路人深表歉意。但该回应能否平息争议，还有待观察。</p>`,
    category: 'shehui-redian',
    author: '法制观察员',
    date: '2026-06-27',
    views: 89000,
    tags: ['隐私权', '户外直播', '律师函', '社会热点'],
    imageSeq: 'article-11',
    imageQuery: 'Smartphone%20camera%20lens%20with%20city%20street%20reflection%2C%20privacy%20concept%2C%20dramatic%20lighting%2C%20warm%20amber%20and%20dark%20tones%2C%20editorial%20photography%2C%20urban%20night%20atmosphere%2C%20mysterious%20mood%2C%20soft%20bokeh%20city%20lights',
  },
  {
    id: '12',
    slug: 'shi-shang-bo-zhu-chao-xi-feng-bo',
    title: '时尚博主被原创设计师指控抄袭，多款服装设计高度雷同',
    excerpt: '多位独立服装设计师联合发声，指控某时尚博主的自创品牌多款产品抄袭他们的原创设计...',
    content: `<p>时尚圈再起抄袭风波。近日，多位独立服装设计师通过社交平台联合发声，指控一位拥有800万粉丝的时尚博主，其自创服装品牌的多款产品与他们的原创设计高度雷同。</p><p>设计师们晒出了详细的对比图，从款式、剪裁到细节处理，相似度惊人。有的甚至只是在颜色上做了微调，整体设计几乎是一比一复制。一位设计师在声明中愤怒地表示："我们辛辛苦苦创作的作品，就这样被拿走贴上别人的标签，这对原创设计是极大的伤害。"</p><p>事件发酵后，该时尚博主的品牌官网已经无法访问，疑似正在紧急调整。但其社交账号上已有大量网友涌入评论区表达不满，要求其对抄袭指控做出回应。</p><p>时尚产业的知识产权保护一直是一个难题。由于服装设计的版权界定相对模糊，维权成本高、周期长，很多原创设计师在面对抄袭时往往选择沉默。此次多位设计师联合发声，或许能够推动行业对原创设计的重视。</p>`,
    category: 'wanghong-baoliao',
    author: '时尚观察家',
    date: '2026-06-26',
    views: 145000,
    tags: ['时尚博主', '抄袭', '原创设计', '版权争议'],
    imageSeq: 'article-12',
    imageQuery: 'Fashion%20design%20sketches%20and%20fabric%20samples%20on%20dark%20wooden%20table%2C%20creative%20studio%20atmosphere%2C%20dramatic%20warm%20lighting%2C%20editorial%20photography%2C%20artistic%20composition%2C%20designer%20workspace%2C%20soft%20golden%20and%20brown%20tones',
  },
];

export const testimonials = [
  {
    id: '1',
    quote: '黑料在线的爆料速度真的太快了，每次有大新闻这里都是第一手的。内容真实可靠，不是那种标题党，推荐给所有喜欢吃瓜的朋友！',
    author: '资深吃瓜群众',
    role: '平台忠实用户',
    imageSeq: 'testimonial-01',
    imageQuery: 'Portrait%20of%20a%20person%20in%20dramatic%20shadow%20and%20warm%20lighting%2C%20mysterious%20atmosphere%2C%20editorial%20portrait%20photography%2C%20dark%20background%2C%20soft%20golden%20rim%20light%2C%20cinematic%20mood%2C%20anonymous%20feel',
  },
  {
    id: '2',
    quote: '作为一个自媒体人，我每天都要在这里蹲点看最新的动态。信息更新及时，分类清晰，是我获取行业资讯的重要渠道。',
    author: '自媒体从业者',
    role: '娱乐行业观察者',
    imageSeq: 'testimonial-02',
    imageQuery: 'Portrait%20silhouette%20with%20warm%20side%20lighting%2C%20professional%20atmosphere%2C%20dramatic%20shadow%20play%2C%20editorial%20portrait%20photography%2C%20mysterious%20mood%2C%20dark%20background%2C%20soft%20golden%20highlights',
  },
];

export const faqItems = [
  {
    question: '黑料在线的内容来源是否可靠？',
    answer: '我们拥有专业的采编团队，所有爆料内容均经过多方核实后再发布。我们坚持真实、客观的报道原则，致力于为读者提供高质量的资讯内容。同时，我们也会标注信息来源，方便读者自行判断。',
  },
  {
    question: '如何在黑料在线投稿爆料？',
    answer: '您可以通过页面底部的订阅表单提交爆料线索，或通过商务合作邮箱与我们取得联系。我们会对每一条爆料线索进行认真核实，确保信息的真实性和准确性。',
  },
  {
    question: '黑料在线的内容更新频率是怎样的？',
    answer: '我们的编辑团队全天候不间断工作，确保第一时间为您带来最新的爆料资讯。重大新闻事件发生后，我们会在最短时间内发布报道，并进行持续跟踪更新。',
  },
  {
    question: '如果发现报道内容有误，如何申请更正？',
    answer: '如果您发现我们的报道中存在事实性错误，请通过商务合作邮箱与我们联系，提供相关证明材料。我们会在核实后第一时间进行更正，并在文章显著位置标注更正说明。',
  },
];